import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Restaura a sessão ao iniciar a aplicação: valida o token salvo na API antes de
  // repor o usuário, e encerra a sessão local se o token estiver inválido/expirado.
  useEffect(() => {
    const loadStoredUser = async () => {
      try {
        const token = authService.getToken();

        if (!token) {
          setUser(null);
          return;
        }

        await authService.verifyToken();

        const storedUser = authService.getCurrentUser();
        setUser(storedUser);

      } catch (err) {
        await logout();
      } finally {
        setLoading(false);
      }
    };

    loadStoredUser();
  }, []);

  const login = async (cpfCnpj, password) => {
    setLoading(true);
    setError(null);

    try {
      const data = await authService.login(cpfCnpj, password);

      if (data.success && data.usuario) {
        setUser(data.usuario);
        return { success: true, data };
      } else {
        return { success: false, error: 'Dados de usuário não retornados' };
      }

    } catch (err) {
      // authService.login já relança um Error com a mensagem da API (sem .response).
      const errorMessage = err.message || 'Erro ao fazer login';
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    await authService.logout();

    setUser(null);
    setError(null);
  };

  const verifyToken = async () => {
    try {
      await authService.verifyToken();
      return true;
    } catch (err) {
      await logout();
      return false;
    }
  };

  const contextValue = {
    user,
    loading,
    error,
    login,
    logout,
    verifyToken,
    isAuthenticated: !!user,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }

  return context;
};

